import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=bc8ca4d8&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=bc8ca4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8ca4d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc8ca4d8')) {
      api.createRecord('bc8ca4d8', component.options)
    } else {
      api.reload('bc8ca4d8', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=bc8ca4d8&scoped=true&", function () {
      api.rerender('bc8ca4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKdNSyPAhn4t/JS/comp/Voucher.vue"
export default component.exports